module.exports = __webpack_public_path__ + "img/imglog.2e753a44.png";